import { Loader } from "components/Loader/Loader";
import "./transition.scss";
import { useEffect, useState } from "react";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Transition_StepOne_TimeOut,
  Transition_Steps,
  Transition_StepThree_TimeOut,
  Transition_StepTwo_TimeOut,
  Transition_Total_Steps,
} from "utilities/Constant";

interface TransitionProps {
  readonly onComplete: () => void | Promise<void>;
}

export default function Transition({ onComplete }: TransitionProps) {
  const [completedSteps, setCompletedSteps] = useState<number[]>([]);

  useEffect(() => {
    const timeouts = [
      setTimeout(() => setCompletedSteps((prev) => [...prev, 0]), Transition_StepOne_TimeOut),
      setTimeout(() => setCompletedSteps((prev) => [...prev, 1]), Transition_StepTwo_TimeOut),
      setTimeout(() => setCompletedSteps((prev) => [...prev, 2]), Transition_StepThree_TimeOut),
    ];

    return () => timeouts.forEach(clearTimeout);
  }, []);

  useEffect(() => {
    if (completedSteps.length === Transition_Total_Steps) {
      void onComplete();
    }
  }, [completedSteps, onComplete]);

  return (
    <div className="transition-loader">
      <Loader />
      <div className="step-wrapper">
        {Transition_Steps.map((step, index) => (
          <div key={index} className="step-container">
            <FontAwesomeIcon icon={solid("circle-check")} className={`checkmark ${completedSteps.includes(index) ? "completed" : ""}`} />
            <div className="step">{step}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
